import { Button } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import MetadataDefinitionStore from "../stores/MetadataDefinitionStore";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: MetadataDefinitionStore;
};

const MetadataExportDependenciesDialog: React.FC<Props> = ({ store }) => {
    const prompt = store.exportDependencyPrompt;

    return (
        <AppModal
            title="Export metadata dependencies"
            open={!!prompt}
            centered
            closable
            onCancel={() => store.closeExportDependencyPrompt()}
            footer={[
                <Button
                    key="cancel"
                    size="large"
                    onClick={() => store.closeExportDependencyPrompt()}
                >
                    Cancel
                </Button>,
                <Button
                    key="skip-calculation"
                    size="large"
                    onClick={() =>
                        store.confirmExportMetadataDefinitions(
                            "ExcludeCalculation",
                        )
                    }
                >
                    Skip calculation
                </Button>,
                <Button
                    key="include-references"
                    type="primary"
                    size="large"
                    onClick={() =>
                        store.confirmExportMetadataDefinitions(
                            "IncludeDirectReferences",
                        )
                    }
                >
                    Include referenced metadata
                </Button>,
            ]}
        >
            {prompt ? (
                <>
                    <p>
                        One or more selected metadata definitions use
                        calculations that reference fields outside this export.
                    </p>
                    <p>
                        Missing referenced metadata:{" "}
                        {prompt.missingReferences
                            .map((reference) => reference.displayName)
                            .join(", ")}
                    </p>
                    <ul>
                        {prompt.affectedDefinitions.map((definition) => (
                            <li key={definition.id}>
                                {definition.displayName}:{" "}
                                {definition.missingReferences
                                    .map((reference) => reference.displayName)
                                    .join(", ")}
                            </li>
                        ))}
                    </ul>
                </>
            ) : null}
        </AppModal>
    );
};

export default observer(MetadataExportDependenciesDialog);
